import { useGetCompanies } from "@/api/console/companies/useGetCompanies";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import Select from "@/components/Select";
import { Button } from "@/components/ui/button";
import { InputWithIcon } from "@/components/ui/input";
import useStatuses from "@/hooks/useStatuses";
import CompanyTable from "@/src/console/(auth)/companies/_components/CompanyTable";
import { BuildingRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

function Companies() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      name: t("company-list"),
      href: "/console/companies",
    },
  ];

  const { data, isLoading } = useGetCompanies();
  const { statuses } = useStatuses();

  const companies = data?.data || [];

  const [search, setSearch] = useState("");

  const progressFilters = [
    {
      label: t("all-progress"),
      value: "0",
    },
    ...statuses.map(({ id, name }) => ({
      label: name,
      value: `${id}`,
    })),
  ];

  const [progressFilter, setProgressFilter] = useState(
    progressFilters[0].value,
  );

  const searchedCompanies = companies.filter((company) =>
    (company.company_name || "").toLowerCase().includes(search.toLowerCase()),
  );

  const filteredCompanies = searchedCompanies.filter((company) =>
    progressFilter === "0"
      ? true
      : company.status.id === parseInt(progressFilter),
  );

  return (
    <>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className="mx-6 mt-8">
        <div className="flex justify-between">
          <div className="my-heading">{t("company-list")}</div>
          <Button onClick={() => navigate("/console/companies/new")}>
            {t("add-company")}
          </Button>
        </div>
        <div className="mt-8 flex justify-between">
          <InputWithIcon
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            Icon={BuildingRegular}
            placeholder="Company name"
          />
          <Select
            width="256px"
            className="bg-white rounded-lg border shadow"
            options={progressFilters}
            value={progressFilter}
            onChange={setProgressFilter}
          />
        </div>
      </div>
      <div className="mx-6 my-8">
        <CompanyTable isLoading={isLoading} data={filteredCompanies} />
      </div>
    </>
  );
}

export default Companies;
